import PropTypes from 'prop-types';
import React from 'react';

const ActionLink = (props) => {
    const onClick = (e) => {
        e.preventDefault();

        if (props.onSelect)
            props.onSelect();
    };

    return <a href="" onClick={onClick} {...props}>{props.children}</a>;
};

ActionLink.propTypes = {
    onSelect: PropTypes.func.isRequired
};

export default ActionLink;